module.exports = __webpack_public_path__ + "static/media/placeholder.8ebd2e83.jpg";